export const IV_TITLE = 'Image Viewer';
export const IV_SUBTITLE = 'Photo taken for Lights & Lenses';
export const IV_DESCRIPTION =
  'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas distinctio quidem deserunt officiis consectetur quaerat quo cupiditate aspernatur.';

// there should be no entry in this array with only text: bug fixes
export const CHANGE_LOG = [
  '0.0.1 - project init',
  '0.1.0 - udacity portfolio project in react',
  '0.1.1 - removed browser console warnings',
  '0.2.0 - bottstrap removal - WIP',
  '0.2.1 - bootstrap removal - from footer & app components',
  '0.2.2 - bootstrap removal - link tag removed',
  '0.2.3 - bootstrap removal - now using m2ui instead of bootstrap',
  '0.2.4 - bootstrap removal - responsive with tablet & desktop compatibility',
  '0.2.5 - header & footer improved',
  '0.2.6 - bootstrap removal - fully responsive',
  '0.2.7 - More UI bug fixes',
  '0.3.0 - renamed component Main to FeaturedContent',
  '0.3.1 - image viewer overlay WIP',
  '0.3.2 - image viewer for tablets & desktop screens',
  '0.3.3 - modified media queries & fixed UI for phones',
  '0.3.4 - image viewer fixes for mobile screens, new UTF close button',
  '0.3.5 - added social links in footer',
  '0.3.6 - image viewer enhancements - sidebar with dummy info',
  '0.3.7 - added overlay around image viewer, disabled scroll outside',
  '0.3.8 - UI bugfixes - image viewer made better',
  '0.3.9 - image viewer footer added',
  '0.3.10 - UI improvements: media query in image viewer for xl screen widths',
  '0.4.0 - image database introduced, thumbnails added, feature image compressed',
  '0.4.1 - 6 photos with filled db, description pending',
  '0.4.2 - Feature image now cycles every month',
  '0.4.3 - Featured image compression: webp instead of jpg',
  '0.4.4 - UX enhancement (first load) min height for feature image',
  '0.4.5 - Header changes',
  '0.4.6 - width issue fix for mobile screen',
  '0.4.7 - min height & onLoad fadeIn transition added',
  '0.4.8 - more photos in gallary, deummy text removed',
];

export const CURRENT_VERSION = '0.4.8';

export const CURRENT_LOG = 'More images added';
